<template>
    <div id="footer_index">
		<div class="container" v-if="showFooter">
			<div style="flex: 1;">
				<div class="title">{{$t('footer_1')}}</div>
				<div class="line"></div>
				<!-- <div class="desc" v-html="data.footer_us_en"></div> -->
                <div class="desc">
                    <div>{{$t('footer_2')}}</div>
                    <ul style="padding-left: 16px;margin:0;">
                        <li>{{$t('footer_3')}}</li>
                        <li>{{$t('footer_4')}}</li>
                        <li>{{$t('footer_5')}}</li>
                    </ul>
                    <div>👉 [{{$t('footer_6')}}]</div>
                </div>
			</div>
			<div style="flex: 1;">
				<div class="title">{{$t('footer_7')}}</div>
				<div class="line"></div>
				<div class="desc">
					<div style="display: flex;">
						<img :src="$STATIC_URL + '/icon_index_tel.png'" class="img-tel"/>
						<div><a :href="'tel:' + data.cfg_phone" style="color: #8A8F99;">{{$t('footer_8')}}：{{data.cfg_phone}}</a></div>
					</div>
					<div style="display: flex;margin-top: 10px;">
						<img :src="$STATIC_URL + '/icon_index_addr.png'" class="img-tel"/>
						<div><a :href="'mailto:' + data.cfg_email" style="color: #8A8F99;">{{$t('footer_9')}}：{{data.cfg_email_en}}</a></div>
					</div>
				</div>	
			</div>
			<!-- <div style="text-align: center;">
				<img :src="data.echat_service" class="serve-img"/>
				<div class="img-desc">服务号</div>
			</div> -->
			<div style="text-align: center;margin-left: 70px;">
				<img :src="data.wechat_customer" class="serve-img"/>
				<div class="img-desc">{{$t('footer_10')}}</div>
			</div>
		</div>
		<div class="copyright">{{$APPCFG.cfg_site_copyright}}</div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
		data() {
			return {
				data: '',
                showFooter: false,
			}
		},
		created() {
			this.onInit();
		},
		methods: {
			onInit() {
				this.$HTTP.get('/index/index/index').then(res => {
					if(res.data.sts == 1) {
						this.data = res.data.data;
					}
				})
			},
		},
        watch: {
            '$route': {
                handler() {
                    if(this.$route.path.indexOf('index') != -1) {
                        this.showFooter = true;
                    }else {
                        this.showFooter = false;
                    }
                },
                deep: true,
                immediate: true
            }
        }
    }
</script>

<style scoped lang="scss">
	#footer_index {
		background: #333;
		.container{
			padding: 66px 15px 48px;
			width: 1480px;
            box-sizing: border-box;
            margin: 0 auto;
			display: flex;
			.title{
				font-size: 17px;
				color: #FFFFFF;
			}
			.line{
				width: 125px;
				background-color: #FFFFFF;
				height: 1px;
			}
			.desc{
				font-size: 13px;
				color: #8A8F99;
				margin-top: 27px;
				width: 80%;
			}
			.img-tel{
				width: 25px;
				height: 25px;
				margin-right: 11px;
			}
			.serve-img{
				width: 150px;
				height: 150px;
			}
			.img-desc{
				margin-top: 26px;
				text-align: center;
				font-size: 13px;
				color: #8A8F99;
			}
		}
		@media (max-width:1600px) {
            .container {
                width: 1200px;
            } 
        }
		.copyright {
			border-top: 1px solid #444444;
			padding: 17px 0 20px;
			font-size: 14px;
			color: #FFFFFF;
			text-align: center;
		}
	}
</style>
